import {  LOCALE_ID, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router, RouterLink }          from '@angular/router';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import {environment} from "../../environments/environment";

declare var window:any;
declare var MellonUrl;
declare var MellonBridge;
declare var $;

@Injectable({
  providedIn: 'root'
})
export class MellonService {

    mellonUrl: any;
    mellonConfig: any;

  constructor(private http: HttpClient, private router: Router, @Inject(PLATFORM_ID) private platform: any, @Inject(LOCALE_ID) public locale: string) {
      console.log("Platform: ", this.platform);
      if (isPlatformBrowser(this.platform)) {
          this.mellonUrl = new MellonUrl(environment.settings.mellon.url);
          console.log("Instantiate: "+environment.settings.mellon.url);
          this.mellonConfig = {
              url: this.mellonUrl.getBase(),
              application: environment.settings.mellon.application,
              mellon: {
                  cookie: {
                      domain: environment.settings.mellon.cookieDomain
                  }
              }
          };
          console.log("My locale: "+this.locale);
          this.mellonConfig.application['languageId'] = this.locale.replace('-','_');
          console.log("using: ",this.mellonConfig);

          window.mellonBridgeInit = (urn) => {
              'use strict';
              var channelInstance, bridge = new MellonBridge(this.mellonConfig);
              var channel = bridge.getNewChannel(urn);
              channel
                  .on('close', function () {
                      var modal = $('div.jqFensterModal:visible');
                      if (modal.length) {
                          $.fensterFinder(modal).close().destroy();
                      }
                  })
                  .on('redirect', function (params) {
                      window.location.href = params.url;
                  })
                  .on('resize', function (w, h) {
                      channelInstance.resize(w, h);

                      $('.jqFensterModalContent iframe')
                          .css({
                              width: w,
                              height: h
                          });
                      $('.jqFensterModal').css('opacity', 1);
                      $('.jqEbony').removeClass('loading');
                  });

              channelInstance = channel.createInstance();
              return channelInstance;
          };

          $(window).on('mellon.modalOpen', () => {
              var $jqEbony = $('.jqEbony');
              if ($jqEbony.length > 1) {
                  // Make sure that there is only one mellon dialogue shown at the same time
                  $jqEbony[0].remove();
                  $('.jqFensterModal').css('opacity', 0);
              }
              // Show the loading spin, if the dialogue is not ready after one second
              $jqEbony.addClass('loading');
              window.setTimeout(function () {
                  $jqEbony.addClass('fadeIn');
              }, 1200);
          });

          $(window).on('mellon.modalClose', () => {
              $('.jqFensterModal').css('opacity', 0);
              $('.jqEbony').remove();
              if (this.router.url == '/logout') {
                  this.router.navigateByUrl('/');
              }
          });
      }
  }

  triggerLink(urlAction, firstParam?, secondParam?, applicationData?, additionalUrlParams?) {
      var link = $('<a>').addClass('jqFenster').data({
            mellonIframeUrl: this.mellonUrl[urlAction](firstParam, secondParam) + (additionalUrlParams || ''),
            selector: '#mellonModal'
        }).appendTo('body');
        setTimeout( () => {
            console.log("triggerLink", applicationData, this.mellonConfig);
            if (applicationData && applicationData['applicationCountryId'] && applicationData['applicationInstanceId']) {
                this.mellonConfig['application']['countryId'] = applicationData['applicationCountryId'];
                this.mellonConfig['application']['instanceId'] = applicationData['applicationInstanceId'];
                this.mellonConfig['application']['languageId'] = this.locale.replace('-','_');
            }
            link.trigger('click');
        });
    };

    static readonly apiPath:string = "/api";
}
